import { Translate } from '../../services';
import type { errorHandler } from '@wix/essentials';

export const commonExportAsyncJobErrors = ({
  translate: t,
}: {
  translate: Translate;
}): errorHandler.StatusCodeMap => ({
  UNAUTHENTICATED: () => ({
    message: t('cairo.export.sessionExpiredMessage'),
    action: {
      text: t('Refresh' as any),
      onClick: () => {
        window.location.reload();
      },
    },
  }),
  PERMISSION_DENIED: () => ({
    message: t('cairo.export.noPermissionsMessage'),
    action: {
      text: t('cairo.export.noPermissionsCTA'),
      onClick: () => {
        window.open(
          'https://support.wix.com/en/article/roles-permissions-overview',
          '_blank',
        );
      },
    },
  }),
});
